import React from 'react';
import { Summary } from 'src/features/MM/components/templates/Summary';
import { PageModelLayout } from '../../components/molecules/PageModelLayout';
import { FilterBar } from '../../components/organisms/FilterBar';
import { GenAIActionButtons } from 'src/components/molecules/GenAIActionButtons';

export const SummaryPage: React.FC = () => {
  return (
    <PageModelLayout
      pageTitle="Summary"
      filterBar={<FilterBar includeAggregation={false} includeDimension />}
      extraButtons={<GenAIActionButtons />}>
      <Summary />
    </PageModelLayout>
  );
};
